import "prismjs";
import "./prism-ruby";
import "./prism-markup-templating";
import "prismjs/components/prism-erb";
